import React, { Component } from 'react'
import Base from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import dateUtil from '../../utils/date.util'
import InputIcon from '../InputIcon'
import InputLabel from '../InputLabel'
import './DatePicker.css'

interface DatePickerProps {
  name: string
  value: string
  label?: string
  time?: boolean
  className?: string
  onChange: (name: string, date: string) => void
}

export default class DatePicker extends Component<DatePickerProps> {
  constructor (props: DatePickerProps) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  get className () {
    const base = 'input-default'
    return `${base} ${this.props.className}`
  }

  get dateFormat () {
    const date = 'MM/dd/yyyy'
    const datetime = `${date} h:mm aa`
    return this.props.time ? datetime : date
  }

  get value () {
    const { value } = this.props
    return value ? new Date(this.props.value) : null
  }

  handleChange (date: Date | null) {
    if (!date) return
    const utcDate = dateUtil.toUtc(date)
    this.props.onChange(this.props.name, utcDate)
  }

  componentDidMount () {
    if (this.value) {
      const utcDate = dateUtil.toUtc(this.value)
      this.props.onChange(this.props.name, utcDate)
    }
  }

  render () {
    return (
      <div className="block">
        <InputLabel text={this.props.label} />
        <InputIcon name="calendar">
          <Base
            className={this.className}
            selected={this.value}
            onChange={this.handleChange}
            dateFormat={this.dateFormat}
            calendarClassName="datePicker"
            closeOnScroll={true}
            shouldCloseOnSelect={true}
            showMonthDropdown={true}
            showYearDropdown={true}
            showTimeSelect={this.props.time} />
        </InputIcon>
      </div>
    )
  }
}
